import styled, { css } from 'styled-components'
import { BaseButton } from '../../base'

export const Overlay = styled.div<{ $open: boolean, $visible: boolean }>(
  ({ theme, $open, $visible }) => css`
    position: fixed;
    inset: 0;
    background-color: ${$visible ? 'rgba(21, 21, 21, 0.48)' : 'transparent'};
    display: flex;
    align-items: flex-end;
    justify-content: center;
    z-index: 1000;
    visibility: ${$open ? 'visible' : 'hidden'};
    opacity: ${$open ? 1 : 0};
    pointer-events: ${$open ? 'auto' : 'none'};
    transition:
      visibility 0.2s,
      opacity 0.2s;
    transition-delay: ${$open ? 0 : '0.2s'};

    @media (min-width: ${theme.breakpoints?.tablet}px) {
      --box-radius: 30px;
      align-items: center;
    }
  `,
)

export const Box = styled.div<{ $open: boolean; $width?: number }>(
  ({ theme, $open, $width }) => css`
    background-color: #fff;
    border-radius: 30px 30px var(--box-radius, 0) var(--box-radius, 0);
    box-shadow: 0 -1px 24px rgba(0, 0, 0, 0.09);
    width: 100%;
    max-height: calc(100vh - 2rem);
    overflow: auto;
    padding: 24px;
    transition:
      transform 0.2s,
      opacity 0.2s;
    transform-origin: bottom;
    transform: translateY(${$open ? 0 : '100%'});
    opacity: ${$open ? 1 : 0};

    @media (min-width: ${theme.breakpoints?.tablet}px) {
      max-width: ${$width ? `${$width}px` : '640px'};
      width: ${$width ? 'calc(100% - 32px)' : 'fit-content'};
    }
  `,
)

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const Title = styled.div`
  font-weight: 500;
  font-size: 20px;
`

export const CloseBtn = styled(BaseButton)`
  width: 24px;
  height: 24px;
  background: none;
  font-size: 18px;
  line-height: 24px;
  color: #364a5c;
`
